import { Box, Link, Typography, styled } from "@mui/material";
import { PropsWithChildren, useEffect } from "react";
import { useTranslation } from "react-i18next";
import AppStoreBadgeEN from "../../assets/img/apple-app-store-badge-en.svg";
import GoogleBadgeEN from "../../assets/img/google-play-badge-en.png";
import SmartOceanLogo from "../../assets/img/smartOcean-black.png";


const GOOGLE_PLAY_URL = "https://play.google.com/store/apps/details?id=no.innomar.sunfish.digicatch";
const APP_STORE_URL = "https://apps.apple.com/no/app/digicatch/id1554882043";

const BadgeImage = styled("img")`
	max-width: 100%;
	height: auto;
`;

type BadgeProps = {
    url: string;
};

function Badge({ url, children }: PropsWithChildren<BadgeProps>) {
	return (
		<Box maxWidth="200px" mx="auto">
			<a href={url} target="_blank" rel="noreferrer">
				{children}
			</a>
		</Box>
	);
}

function AppleBadge() {
	const { t } = useTranslation();

	return (
		<Badge url={APP_STORE_URL}>
			<BadgeImage
				src={AppStoreBadgeEN}
				alt={t("appStore")}
				style={{ width: 500 }}
			/>
		</Badge>
	);
}

function GoogleBadge() {
    const { t } = useTranslation();
	
    return (
		<Badge url={GOOGLE_PLAY_URL}>
			<BadgeImage src={GoogleBadgeEN} alt={t("googlePlay")}
                style={{ width: 500 }}
            />
		</Badge>
	);
}



export function App() {
    const history = window.history;

    useEffect(() => {
        const userAgent = navigator.userAgent.toLowerCase();
        const isMobile = /iphone|ipod|ipad|android/.test(userAgent);
        if (isMobile) {
            window.location.href =
                navigator.userAgent.indexOf("Android") > -1
                    ? GOOGLE_PLAY_URL
                    : APP_STORE_URL;
        }
    }, []);

    return (
        <Box display="flex" flexDirection="column" alignItems="center" width="100%">
            <Box padding="40px">
                <img src={SmartOceanLogo} alt="Smart Ocean Logo" style={{ height: "40px" }} />
            </Box>
            <Box display="flex" justifyContent="center" width="100%" flexDirection="column" gap={4} textAlign="center">
                <Typography textAlign="center" fontSize="1rem" fontWeight="bold">Download the app to get started</Typography>
                <AppleBadge />
                <GoogleBadge />

                {/* a new tab will set history.length to 1 */}
                {history.length > 2 && (
                    <Link href="#" onClick={() => history.back()}>
                        Go back
                    </Link>
                    )
                }
                    
            </Box>
        </Box>
    );
}